/**
 * Custom error class
 * @class
 * @public
 */
export default class CustomError {
  /**
   * Creates an instance of a custom error
   * @param {String} code - The error code
   * @param {String} message - The error message
   */
  constructor(code, message) {
    this.code = code;
    this.message = message;
  }
}
